import './ContactForm.css'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import {toast, ToastContainer} from 'react-toastify'
import TwoInputs from '../../common/TwoInputs/TwoInputs';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

function ContactForm(){
  const { t } = useTranslation();

  const [form , setForm] = useState(
    {
      name:"",
      email:"",
      phone:"",
      subject:"",
      message:""
    }
  )

  const handleSendBtn = (e)=>{
    e.preventDefault()
    console.log(form)
    toast.success(t('messageSent'))
  }
  return (
    <>
      <ToastContainer/>
    <div className='contactForm-container container'>
      <div className='contactForm-content content'>
        <div className='leftSide'>
          <MapContainer center={[30.9702, 31.1685]} zoom={13} className='map'>
            <TileLayer
              url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
              attribution='&copy; OpenStreetMap contributors'
            />
            <Marker position={[30.9702, 31.1685]}>
              <Popup>عيادة مارك عاطف</Popup>
            </Marker>
          </MapContainer>
        </div>
        <div className='rightSide'>
          <div className='header'>
            <h2 className='h-after-effect'>{t('contactWithUs')}</h2>
            <p>
              {t('contactWithUsDesc')}
            </p>
          </div>
          <form>
            <TwoInputs typeOne={"text"} placeOne={t('name')} typeTwo={"email"} placeTwo={t('email')} fnOne={(e)=>setForm((prev)=>({...prev , name:e.target.value}))} fnTwo={(e)=>setForm((prev)=>({...prev , email:e.target.value}))}/>
            <TwoInputs typeOne={"number"} placeOne={t('phone')} typeTwo={"text"} placeTwo={t('subject')} fnOne={(e)=>setForm((prev)=>({...prev , phone:e.target.value}))} fnTwo={(e)=>setForm((prev)=>({...prev , subject:e.target.value}))}/>
            <textarea placeholder={t('yourMessage')} onChange={(e)=>setForm((prev)=>({...prev , message:e.target.value}))}></textarea>
            <button className='addBtn' onClick={(e)=>handleSendBtn(e)}>{t('send')}</button>
          </form>
        </div>
      </div>
    </div>
    </>
  );
}
export default ContactForm